'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPurchasedProductsByAccount = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * getProducts
 * 
 * Fetches a list of products purchased by an account.
 * @param {String} feis_id
 * @param {String} acct_id
 */
var getPurchasedProductsByAccount = exports.getPurchasedProductsByAccount = function getPurchasedProductsByAccount(feis_id, acct_id) {
  return function (dispatch) {

    return dispatch(_defineProperty({
      feis_id: feis_id,
      acct_id: acct_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/accounts/' + acct_id + '/purchases'
      },
      types: ['GET_PURCHASED_PRODUCTS_BY_ACCOUNT_FOR_FEIS_START', 'GET_PURCHASED_PRODUCTS_BY_ACCOUNT_FOR_FEIS', 'GET_PURCHASED_PRODUCTS_BY_ACCOUNT_FOR_FEIS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/getPurchasedProductsByAccount.js
// module id = 238
// module chunks = 0